import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import DownloadIcon from '@mui/icons-material/Download';
import {
  Container,
  Typography,
  Card,
  Divider,
  Box,
  CardMedia,
  Button,
  styled,
  createTheme,
  ThemeProvider
} from '@mui/material';
import moment from 'moment';


const statistiquesSanteData = [
    {
    ministere: 'MINISTERE DE LA SANTE PUBLIQUE',
    annuaires: 'ANNUAIRE DES STATISTIQUES SANITAIRES EDITION 2024',
    description: 'Les statistiques sanitaires récentes pour l\'année 2024, y compris des données épidémiologiques et des résultats des efforts de santé publique contre le VIH/SIDA.',
    date: "2025-08-31",
    image: 'documents/sectoriels/annuaire2020.png',
    link: "/documents/Sectorials/Annuaire_Statistiques_Sanitaires_2024.pdf" 
  },
  {
    ministere: 'MINISTERE DE LA SANTE PUBLIQUE ET DE LA LUTTE CONTRE LE SIDA',
    annuaires: 'ANNUAIRE DES STATISTIQUES SANITAIRES EDITION 2023',
    description: 'Les statistiques sanitaires récentes pour l\'année 2023, y compris des données épidémiologiques et des résultats des efforts de santé publique contre le VIH/SIDA.',
    date: "2023-12-31",
    image: 'documents/sectoriels/annuaire2020.png',
    link: "/documents/Sectorials/Annuaire-Statistique-2023-version-officielle-a-diffuser.pdf" 
  },
  {
    ministere: 'MINISTERE DE LA SANTE PUBLIQUE ET DE LA LUTTE CONTRE LE SIDA',
    annuaires: 'ANNUAIRE DES STATISTIQUES SANITAIRES EDITION 2022',
    description: 'L’état des services de santé publique pour l’année 2022, détaillant les services offerts, l\'accès aux soins et les mesures de prévention.',
    date: "2022-12-31",
    image: 'documents/sectoriels/annuaire2020.png',  
    link: "/documents/Sectorials/AnnuaireStatistique2022.pdf" 
  },
  {
    ministere: 'MINISTERE DE LA SANTE PUBLIQUE ET DE LA LUTTE CONTRE LE SIDA',
    annuaires: 'ANNUAIRE DES STATISTIQUES SANITAIRES EDITION 2021',
    description: 'Données clés sur les services de santé publique, y compris des statistiques sur la santé maternelle et infantile et l’accès aux soins de santé pour l’année 2021.',
    date: "2021-12-31",
    image: 'documents/sectoriels/annuaire2021.png',
    link: "/documents/Sectorials/Annuaire-Statistique-de-la-sante-2021.pdf" 
  },
  {
    ministere: 'MINISTERE DE LA SANTE PUBLIQUE ET DE LA LUTTE CONTRE LE SIDA',
    annuaires: 'ANNUAIRE DES STATISTIQUES SANITAIRES EDITION 2020',
    description: 'Les statistiques sanitaires concernant les structures de santé, les services offerts et les défis rencontrés durant l\'année 2020, dans le contexte de la pandémie de COVID-19.',
    date: "2020-12-31",
    image: 'documents/sectoriels/annuaire2020.png',
    link: "/documents/Sectorials/Annuaire-statistique-2020-2.pdf" 
  },
];

function MinistereSante() {
  const [visibleCount, setVisibleCount] = useState(4); 
  const theme = createTheme({
    palette: {
      primary: {
        main: '#388E3C'
      },
      background: {
        default: '#f5f5f5'
      }
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      body1: {
        fontSize: 16,
        letterSpacing: 0.5,
        color: '#6B778C'
      },
      h4: {
        fontWeight: '600'
      }
    }
  });

  const StyledCard = styled(Card)(({ theme }) => ({
    borderRadius: '12px',
    overflow: 'hidden',
    marginBottom: '20px'
  }));

  const handleShowMore = () => {
    setVisibleCount((prevCount) => Math.min(prevCount + 2, statistiquesSanteData.length));
  };

  return (
    <ThemeProvider theme={theme}>
      <div style={{ backgroundColor: theme.palette.background.default, paddingBottom: '32px' }}>
        <NavigationBar />
        <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
          <Typography variant="h4" align="justify" gutterBottom style={{ color: theme.palette.primary.main, marginBottom: '16px' }}>
             Ministère de la Santé publique
          </Typography>
          <Divider style={{ margin: '16px 0' }} />
          <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px' }}>
            Les statistiques sanitaires récentes, les services de santé publique et les efforts en cours pour lutter contre le VIH/SIDA.
          </Typography>

          {statistiquesSanteData.slice(0, visibleCount).map((statistique, index) => (
            <StyledCard key={index} elevation={1}>
              <Box sx={{ display: 'flex' }}>
                <a 
                  href={statistique.link} 
                  style={{ textDecoration: 'none', color: 'inherit' }} 
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <CardMedia
                    component="img"
                    sx={{ width: 71, height: 100, m: 2 }}
                    image={statistique.image} 
                    alt={statistique.annuaires}
                  />
                </a>
                <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                  <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px', color: theme.palette.primary.main }}>
                    <a 
                      href={statistique.link} 
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: 'none', color: 'inherit' }}
                    >
                      {<DownloadIcon />}{statistique.annuaires}
                    </a>
                  </Typography>
                  <Typography variant="body2" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                    {statistique.description}
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    Publié en {moment(statistique.date).format('MMMM YYYY')}
                  </Typography>
                </Box>
              </Box>
            </StyledCard>
          ))}

          {visibleCount < statistiquesSanteData.length && (
            <Button 
              onClick={handleShowMore} 
              style={{
                marginTop: '20px',
                backgroundColor: theme.palette.primary.main,
                color: 'white'
              }}
            >
              Plus de Statistiques
            </Button>
          )}
        </Container>
        <br />
        <br />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default MinistereSante;